/**
 *  @fileOverview Course listing module, loads course data into accordions
 *
 *  @author       Chris Hill
 *
 */

function CourselistingModule (axios) {
  /**
   * @description Loads data into accordion instances.
   *
   * @example
   * //
   * @returns {boolean} // null.
   */
  this.init = function () {
    /**
     * Setup promise so that the dependant modules can wait till promise is returned
     */
    return new Promise((resolve, reject) => {
      /**
       * Get all instances of course lists
       */
      const clists = document.querySelectorAll('.courselist')

      /**
       * Only run if courselist containers are present on page
       */
      if (clists.length > 0) {
        let url = 'https://www.ecu.edu.au/degrees/shared-content/nested-content/funnelback-json-course-info'

        /**
         * Check for localhost and recache if found
         */
        if (document.location.href.includes('domain.local:')) {
          url = 'https://www.ecu.edu.au/degrees/shared-content/nested-content/funnelback-json-course-info/_nocache'
        }

        /**
         * Retrieve unit info from Funnelback via WebCMS rest object
         */
        axios.get(url)
          .then(response => {
            const courses = response.data.results

            // console.log(courses)

            /**
             * Loop through all course list containers on page
             */
            clists.forEach((clist) => {
              /**
               * Get all accordion elements in the courselist
               */
              let accordions = clist.querySelectorAll('li.accordion__item')

              /**
               * Check for toppings and sprinkle
               */
              const topping = typeof getUrlVars()['topping'] !== 'undefined' ? getUrlVars()['topping'] : ''
              const sprinkle = typeof getUrlVars()['sprinkle'] !== 'undefined' ? getUrlVars()['sprinkle'] : ''

              if (accordions.length > 0) {
                /**
                 * Loop through each accordion element inside the course list
                 */
                accordions.forEach((accordion, i) => {
                  /**
                   * Initialise potential data parameters
                   */
                  let studyarea = ''
                  let disciplines = []
                  let campuses = []
                  let isvet = ''
                  let doubledegree = ''
                  let studymode = ''
                  let coursetype = ''
                  let studylevel = ''
                  let residenttype = ''
                  let availability = ''
                  let showonline = false
                  let currentyear = ''
                  let studymodeicon = false
                  let exclude = []

                  /**
                   * Check if studyarea data attribute exists
                   */
                  if (typeof accordion.dataset.studyarea !== 'undefined') {
                    if (accordion.dataset.studyarea !== '') {
                      studyarea = accordion.dataset.studyarea.toLowerCase()
                    }
                  }

                  /**
                   * Check for disciplines and update
                   */
                  if (typeof accordion.dataset.discipline !== 'undefined') {
                    if (accordion.dataset.discipline !== '') {
                      disciplines = accordion.dataset.discipline.split(',')

                      /**
                       * Clean up data attribute values to make it easier to test against
                       */
                      disciplines = disciplines.map(d => {
                        return d.trim().toLowerCase()
                      })
                    }
                  }

                  /**
                   * Check for campuses and update
                   */
                  if (typeof accordion.dataset.campus !== 'undefined') {
                    if (accordion.dataset.campus !== '') {
                      campuses = accordion.dataset.campus.split(',')

                      /**
                       * Clean up data attribute values to make it easier to test against
                       */
                      campuses = campuses.map(c => {
                        return c.trim().toLowerCase()
                      })
                    }
                  }

                  /**
                   * Check for isvet and update
                   */
                  if (typeof accordion.dataset.isvet !== 'undefined') {
                    if (accordion.dataset.isvet !== '') {
                      if (accordion.dataset.isvet.toLowerCase() === 'y' || accordion.dataset.isvet.toLowerCase() === 'yes' || accordion.dataset.isvet.toLowerCase() === 'true') {
                        isvet = 'Y'
                      } else {
                        isvet = 'N'
                      }
                    }
                  }

                  /**
                   * Check for doubledegree and update
                   */
                  if (typeof accordion.dataset.doubledegree !== 'undefined') {
                    if (accordion.dataset.doubledegree !== '') {
                      if (accordion.dataset.doubledegree.toLowerCase() === 'y' || accordion.dataset.doubledegree.toLowerCase() === 'yes' || accordion.dataset.doubledegree.toLowerCase() === 'true') {
                        doubledegree = 'Y'
                      } else {
                        doubledegree = 'N'
                      }
                    }
                  }

                  /**
                   * Check for studymode and update
                   */
                  if (typeof accordion.dataset.studymode !== 'undefined') {
                    if (accordion.dataset.studymode !== '') {
                      studymode = accordion.dataset.studymode.toLowerCase()
                    }
                  }

                  /**
                   * Check for coursetype and update
                   */
                  if (typeof accordion.dataset.coursetype !== 'undefined') {
                    if (accordion.dataset.scoursetype !== '') {
                      coursetype = accordion.dataset.coursetype.toLowerCase()
                    }
                  }

                  /**
                   * Check for studylevel and update
                   */
                  if (typeof accordion.dataset.studylevel !== 'undefined') {
                    if (accordion.dataset.studylevel !== '') {
                      studylevel = accordion.dataset.studylevel.toLowerCase()
                    }
                  }

                  /**
                   * Check for residenttype and update
                   */
                  if (typeof accordion.dataset.residenttype !== 'undefined') {
                    if (accordion.dataset.residenttype !== '') {
                      residenttype = accordion.dataset.residenttype.toLowerCase()
                    }
                  }

                  /**
                   * Check for semester availability and update
                   */
                  if (typeof accordion.dataset.availability !== 'undefined') {
                    if (accordion.dataset.availability !== '') {
                      availability = accordion.dataset.availability.toLowerCase().replace(/\s/g, '')
                    }
                  }

                  /**
                   * Check for online and update
                   */
                  if (typeof accordion.dataset.showonline !== 'undefined') {
                    if (accordion.dataset.showonline !== '') {
                      if (accordion.dataset.showonline.toLowerCase() === 'y' || accordion.dataset.showonline.toLowerCase() === 'yes' || accordion.dataset.showonline.toLowerCase() === 'true') {
                        showonline = true
                      }
                    }
                  }

                  /**
                   * Check for currentyear and update
                   */
                  if (typeof accordion.dataset.currentyear !== 'undefined') {
                    if (accordion.dataset.currentyear !== '') {
                      if (accordion.dataset.currentyear.toLowerCase() === 'y' || accordion.dataset.currentyear.toLowerCase() === 'yes' || accordion.dataset.currentyear.toLowerCase() === 'true') {
                        currentyear = 'Y'
                      }
                    }
                  }

                  /**
                   * Check for online and update
                   */
                  if (typeof accordion.dataset.studymodeicon !== 'undefined') {
                    if (accordion.dataset.studymodeicon !== '') {
                      if (accordion.dataset.studymodeicon.toLowerCase() === 'y' || accordion.dataset.studymodeicon.toLowerCase() === 'yes' || accordion.dataset.studymodeicon.toLowerCase() === 'true') {
                        studymodeicon = true
                      }
                    }
                  }

                  /**
                   * Check for exclude and update
                   */
                  if (typeof accordion.dataset.exclude !== 'undefined') {
                    if (accordion.dataset.exclude !== '') {
                      exclude = accordion.dataset.exclude.split(',')

                      /**
                       * Clean up data attribute values to make it easier to test against
                       */
                      exclude = exclude.map(e => {
                        return e.trim().toLowerCase()
                      })
                    }
                  }

                  /**
                   * Filter down courses to only ones that match all the params
                   */
                  const matches = courses.filter(course => {
                    /**
                     * Assume true and set to false if any test fails to find a match
                     */
                    let flag = true

                    if (studyarea !== '') {
                      let found = false

                      /**
                       * Loop through the studyAreas
                       */
                      course.studyAreas.forEach((area) => {
                        if (studyarea === area.toLowerCase()) {
                          found = true
                        }
                      })

                      flag = found
                    }

                    if (disciplines.length > 0 && flag) {
                      /**
                       * Check any matches in data attribute disciples or course list disciplines
                       */
                      if (!course.disciplines.some(r => disciplines.includes(r.toLowerCase()))) {
                        flag = false
                      }
                    }

                    /**
                     * Only do test if there are campus attributes and test has not already failed. Repeat for all following tests
                     */
                    if (campuses.length > 0 && flag) {
                      let found = false

                      /**
                       * Loop through the course locations and see if the is a match in campuses array and if set to Yes
                       */
                      course.studyLocations.forEach((loc) => {
                        if (campuses.includes(loc.campus.toLowerCase()) && loc.available === 'Y') {
                          found = true
                        }
                      })

                      flag = found
                    }

                    if (isvet !== '' && flag) {
                      /**
                       * Check isvet for matching value in course data
                       */
                      if (isvet !== course.courseIsVET) {
                        flag = false
                      }
                    }

                    if (doubledegree !== '' && flag) {
                      /**
                       * Check doubledegree for matching value in course data
                       */
                      if (doubledegree !== course.courseIsDblDegree) {
                        flag = false
                      }
                    }

                    if (studymode !== '' && flag) {
                      let found = false

                      /**
                       * Check if data is full or part time and if course matches
                       */
                      if ((studymode === 'fulltime' && course.studyMode[0].fullTime === 'Y') || (studymode === 'parttime' && course.studyMode[0].partTime === 'Y')) {
                        found = true
                      }

                      flag = found
                    }

                    if (studylevel !== '' && flag) {
                      /**
                       * Check studylevel for matching value in course data
                       */
                      if (studylevel !== course.studyLevel.toLowerCase()) {
                        flag = false
                      }
                    }

                    if (coursetype !== '' && flag) {
                      /**
                       * Check coursetype for matching value in course data
                       */
                      if (coursetype !== course.courseType.toLowerCase()) {
                        flag = false
                      }
                    }

                    if (residenttype !== '' && flag) {
                      let found = false

                      /**
                       * Check if data is domestic or international and if course matches
                       */
                      if (((residenttype === 'domestic' && course.residentAvailability[0]['Domestic-onCampus'] === 'Y') || (residenttype === 'domestic' && course.residentAvailability[0]['Domestic-online'] === 'Y')) || ((residenttype === 'international' && course.residentAvailability[0]['International-onCampus'] === 'Y') || (residenttype === 'international' && course.residentAvailability[0]['International-online'] === 'Y'))) {
                        found = true
                      }

                      flag = found
                    }

                    if (availability !== '' && flag) {
                      let found = false

                      /**
                       * Check if data is semester 1 or 2 and if course matches
                       */
                      if (((availability === 'semester1' && course.semesterAvailability[0]['Domestic-Sem1'] === 'Y') || (availability === 'semester1' && course.semesterAvailability[0]['International-Sem1'] === 'Y')) || ((availability === 'semester2' && course.semesterAvailability[0]['Domestic-Sem2'] === 'Y') || (availability === 'semester2' && course.semesterAvailability[0]['International-Sem2'] === 'Y'))) {
                        found = true
                      }

                      flag = found
                    }

                    if (currentyear !== '' && flag) {
                      let found = false

                      /**
                       * Check if data is current year or less and if course matches
                       */
                      if (course.hasOwnProperty('courseFirstOfferedDt')) {
                        if (course.courseFirstOfferedDt !== '') {
                          const courseyear = course.courseFirstOfferedDt.split('-')[2]
                          const thisyear = new Date().getFullYear()

                          if (parseInt(courseyear) <= parseInt(thisyear)) {
                            found = true
                          }
                        }
                      }

                      flag = found
                    }

                    if (exclude.length > 0 && flag) {
                      /**
                       * Check any matches in data attribute exclude
                       */
                      if (exclude.includes(course.courseCode.toLowerCase())) {
                        flag = false
                      }
                    }

                    return flag
                  })

                  /**
                   * Tempary arrays for sorting courses by course type
                   */
                  let nacert = []
                  let certiv = []
                  let entryp = []
                  let dipu = []
                  let dipv = []
                  let adip = []
                  let adeg = []
                  let bdeg = []
                  let gcert = []
                  let gdip = []
                  let mast = []
                  let doc = []

                  /**
                   * Loop through and push into arrays based on course type
                   */
                  matches.forEach((match) => {
                    switch (match.courseType) {
                      case 'Non Award Certificate':
                        nacert.push(match)
                        break
                      case 'Certificate IV (VET)':
                        certiv.push(match)
                        break
                      case 'Entry Pathways (Undergraduate)':
                        entryp.push(match)
                        break
                      case 'Diploma (Undergraduate)':
                        dipu.push(match)
                        break
                      case 'Diploma (VET)':
                        dipv.push(match)
                        break
                      case 'Advanced Diploma (VET)':
                        adip.push(match)
                        break
                      case 'Associate Degrees (Undergraduate)':
                        adeg.push(match)
                        break
                      case 'Bachelors Degrees (Undergraduate)':
                        bdeg.push(match)
                        break
                      case 'Honours (Undergraduate)':
                        bdeg.push(match)
                        break
                      case 'Graduate Certificate (Postgraduate)':
                        gcert.push(match)
                        break
                      case 'Graduate Diploma (Postgraduate)':
                        gdip.push(match)
                        break
                      case 'Master by Coursework (Postgraduate)':
                        mast.push(match)
                        break
                      case 'Master by Research (Postgraduate)':
                        mast.push(match)
                        break
                      case 'Doctorate (Postgraduate)':
                        doc.push(match)
                        break
                      default:
                        // no matches
                    }
                  })

                  /**
                   * Merge arrays so that the end result is sorted by course type
                   */
                  const sorted = nacert.concat(certiv, entryp, dipu, dipv, adip, adeg, bdeg, gcert, gdip, mast, doc)

                  /**
                   * Create markup for each course. Check for national course code and new offering
                   */
                  let list = sorted.map(c => {
                    /**
                     * Check for studymodeicon flag and build icons if true
                     */
                    let smo = ''
                    if (studymodeicon) {
                      if (c.studyMode[0].fullTime === 'Y') {
                        smo += `<span class="badge badge--fullTime" aria-label="Full Time" title="Full Time">FT</span>`
                      }
                      if (c.studyMode[0].partTime === 'Y') {
                        smo += `<span class="badge badge--partTime" aria-label="Part Time" title="Part Time">PT</span>`
                      }
                    }
                    const newoff = c.newOffering !== '' ? `<span class="badge">New</span>` : ''
                    const courseTitleTrim = c.courseTitle.trim()
                    const spclass = sprinkle.toLowerCase() === c.courseCode.toLowerCase() ? ' class="courseList__sprinkle headingBackgroundLine"><span class="headingBackgroundLine__span"' : ''
                    return `<li${spclass}><a href="${c.courseURL}">${c.courseNationalCode !== '' ? `${newoff}${courseTitleTrim} ` : `${newoff}${c.courseNationalCode}${courseTitleTrim}`}${smo}</a></span></li>`
                  })

                  let HTML = `<ul class="courseList__content">${list.join('')}</ul>`

                  /**
                   * If extra online list needs to be generated
                   */
                  if (showonline) {
                    /**
                     * Filter down courses show ones available online
                     */
                    const online = sorted.filter(course => {
                      if (course.hasOwnProperty('residentAvailability')) {
                        if (course.residentAvailability[0]['International-online'] === 'Y') {
                          return true
                        }
                      }
                    })

                    // console.log(online)

                    /**
                     * Only show if there are results
                     */
                    if (online.length > 0) {
                      HTML += `<h4 class="base__lead">Courses you can study online in your home country.</h4>`

                      /**
                       * Create markup for each course. Check for national course code and new offering
                       */
                      let olist = online.map(c => {
                        const newoff = c.newOffering !== '' ? `<span class="badge">New</span>` : ''
                        const courseTitleTrim = c.courseTitle.trim()
                        const spclass = sprinkle.toLowerCase() === c.courseCode.toLowerCase() ? ' class="sprinkle"' : ''
                        return `<li${spclass}><a href="${c.courseURL}">${c.courseNationalCode !== '' ? `${newoff}${courseTitleTrim} ` : `${newoff}${c.courseNationalCode}${courseTitleTrim}`}</a></li>`
                      })

                      HTML += `<ul class="courseList__content">${olist.join('')}</ul>`
                    }
                  }

                  /**
                   * Out put final markup
                   */
                  accordion.querySelector('.accordion__body').innerHTML = HTML

                  /**
                   * Check if accordion topping data attribute is set and matches topping in URL. If so add open class to accordion body
                   */
                  if (typeof accordion.dataset.topping !== 'undefined') {
                    if (accordion.dataset.topping.toLowerCase() === topping.toLowerCase() && accordion.dataset.topping !== '') {
                      accordion.querySelector('.accordion__body').classList.toggle('accordion__body--open')
                      accordion.querySelector('.accordion__title').classList.toggle('accordion__title--open')
                      accordion.querySelector('.accordion__title').setAttribute('aria-expanded', 'true')
                    }
                  }
                })
              }
            })

            /**
             * Resolve promise so dependant code can be excecuted
             */
            resolve('Success')
          })
          .catch(e => {
            console.log(e)
          })
      } else {
        resolve('No course listings')
      }

      /**
       * @description Function gets URL params as named array https://html-online.com/articles/get-url-parameters-javascript/.
       *
       * @example
       * //
       * @returns {Array} Param1, Param2.
       */
      function getUrlVars () {
        var vars = {}
        window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
          vars[key] = value
        })
        return vars
      }
    })
  }
}

module.exports = CourselistingModule
